import { Secrets, FirebaseConfig } from './keys.stage';

export const environment = {
  questionnaireBackendRootUrl: 'https://api.survey-stage.kekeno.co.nz',
  defaultQuestionnaireGuid: 'b319e607-8da1-4ffa-910d-f09668c99055',
  defaultQuestionSetGuid: 'b1680af9-cd95-4881-8752-44da67699842',
  apiKey: Secrets.apiKey,
  inBeta: true,
  analytics: false,
  firebaseConfig: FirebaseConfig,
};
